import React, { useState } from "react";
import CurriculumTree from "./CurriculumTree";
import CohortLeaderboard from "./CohortLeaderboard";

function CohortSidebar({ curriculum, leaderboard, myProgress, selectedChallenge, onSelectChallenge, onFetchLeaderboard }) {
  const [activeTab, setActiveTab] = useState("content");

  const handleLeaderboardClick = () => {
    setActiveTab("leaderboard");
    if (onFetchLeaderboard) {
      onFetchLeaderboard();
    }
  };

  return (
    <div className="flex flex-col h-full">
      {/* Sidebar Tabs */}
      <div className="flex border-b border-zinc-800 flex-shrink-0">
        <button
          onClick={() => setActiveTab("content")}
          className={`flex-1 py-3 text-sm font-display font-medium transition-colors ${
            activeTab === "content"
              ? "text-amber-400 border-b-2 border-amber-400"
              : "text-zinc-500 hover:text-zinc-300"
          }`}
        >
          Content
        </button>
        <button
          onClick={handleLeaderboardClick}
          className={`flex-1 py-3 text-sm font-display font-medium transition-colors ${
            activeTab === "leaderboard"
              ? "text-amber-400 border-b-2 border-amber-400"
              : "text-zinc-500 hover:text-zinc-300"
          }`}
        >
          Leaderboard
        </button>
      </div>

      {/* Sidebar Content */}
      <div className="flex-1 overflow-y-auto p-3">
        {activeTab === "content" ? (
          <CurriculumTree
            curriculum={curriculum}
            selectedChallenge={selectedChallenge}
            onSelectChallenge={onSelectChallenge}
          />
        ) : (
          <CohortLeaderboard leaderboard={leaderboard} myProgress={myProgress} />
        )}
      </div>
    </div>
  );
}

export default CohortSidebar;
